import React from 'react';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import { withStyles } from '@material-ui/core/styles';
//import { ThemeProvider } from '@material-ui/core/styles';
import { withRouter } from 'react-router';

import CircularProgress from '@material-ui/core/CircularProgress';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';
import FiberNewIcon from '@material-ui/icons/FiberNew'; // new
//import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty'; // wait
import SnoozeTwoToneIcon from '@material-ui/icons/SnoozeTwoTone'; // wait
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn'; //done
//import WorkIcon from '@material-ui/icons/Work'; //work
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun'; //work
import { DE as TextDE } from '../../../lib/Text';

const componentOf = {
  done: <AssignmentTurnedInIcon style={{ color: 'inherit', backgroundColor: 'inherit' }} />,
  working: <DirectionsRunIcon style={{ color: 'inherit', backgroundColor: 'inherit' }} />,
  wait: <SnoozeTwoToneIcon style={{ color: 'inherit', backgroundColor: 'inherit' }} />,
  new: <FiberNewIcon style={{ color: 'inherit', backgroundColor: 'inherit' }} />,
};

const styles = (theme) => ({
  chip: {
    padding: theme.spacing(1.5, 1),
    fontSize: '110%',
  },
});

class StatusChip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stateSelectAnchorEl: null,
      states: [],
      status: null,
      model: 'procedures',
    };
  }

  handleStateSelectClose = () => {
    this.setState({ stateSelectAnchorEl: null });
  };

  handleStateSelectOpen = (event) => {
    if (this.props.isInbox) return;
    this.setState({ stateSelectAnchorEl: event.currentTarget });
  };

  handleSetStateSelect = async (id) => {
    let formData = new FormData();
    formData.append('_method', 'PUT');
    formData.append('status_id', id);

    await fetch(
      process.env.REACT_APP_API_URL +
        '/api/' +
        this.state.model +
        '/' +
        this.props.match.params.uuid,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${this.props.Authentication.access_token}`,
        },
        body: formData,
      },
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then((json) => {
        this.setState({ stateSelectAnchorEl: null }, () => this.props.callback());
      })
      .catch((error) => {
        return false;
      });
  };

  componentDidMount() {
    fetch(process.env.REACT_APP_API_URL + '/api/' + this.state.model + '/states', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.props.Authentication.access_token}`,
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then((json) => {
        this.setState({
          states: json,
        });
      })
      .catch((error) => {
        return false;
      });
  }

  render() {
    const { classes } = this.props;

    if (this.props.isFetching) {
      return <Chip className={classes.chip} label={<CircularProgress />} />;
    }

    return (
      <>
        {/* Status and ID */}
        <Tooltip
          title={this.props.isInbox ? TextDE.new : this.props.status.description}
          aria-label='add'
        >
          <Chip
            className={classes.chip}
            label={this.props.isInbox ? TextDE.new : this.props.status.name}
            variant='outlined'
            icon={componentOf[this.props.isInbox ? 'new' : this.props.status.icon]}
            style={
              this.props.isInbox
                ? { color: 'rgb(255, 255, 255)', backgroundColor: 'rgb(255, 0, 0)' }
                : this.props.status.style
            }
            onClick={this.handleStateSelectOpen}
          />
        </Tooltip>
        <Menu
          anchorEl={this.state.stateSelectAnchorEl}
          keepMounted
          open={Boolean(this.state.stateSelectAnchorEl)}
          onClose={this.handleStateSelectClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <MenuItem
            key={'hint'}
            disabled
            style={{ color: '#6b6b6b', opacity: 1, borderBottom: '1px solid #6b6b6b' }}
          >
            {TextDE.procedure.stateChangeHint}
          </MenuItem>
          {this.state.states.map((item, index) => {
            return (
              <MenuItem key={item.id} onClick={() => this.handleSetStateSelect(item.id)}>
                {item.name}
              </MenuItem>
            );
          })}
        </Menu>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  Authentication: state.Authentication,
  Router: state.router,
});

const mapDispatchToProps = (dispatch) => ({ dispatch, push });

export default compose(
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(StatusChip);
